/* eslint-disable @typescript-eslint/naming-convention */
var BxfIconTypeEnum;
(function (BxfIconTypeEnum) {
    BxfIconTypeEnum["fill"] = "fill";
    BxfIconTypeEnum["text"] = "text";
    BxfIconTypeEnum["API"] = "API";
    BxfIconTypeEnum["account"] = "account";
    BxfIconTypeEnum["action-12"] = "action-12";
    BxfIconTypeEnum["action"] = "action";
    BxfIconTypeEnum["actionarrow-back"] = "actionarrow-back";
    BxfIconTypeEnum["actionarrow-down"] = "actionarrow-down";
    BxfIconTypeEnum["actionarrow-forward"] = "actionarrow-forward";
    BxfIconTypeEnum["actionarrow-up"] = "actionarrow-up";
    BxfIconTypeEnum["add"] = "add";
    BxfIconTypeEnum["alert-2"] = "alert-2";
    BxfIconTypeEnum["alert-bell-subtle"] = "alert-bell-subtle";
    BxfIconTypeEnum["alert-bell"] = "alert-bell";
    BxfIconTypeEnum["alert-bold-large"] = "alert-bold-large";
    BxfIconTypeEnum["alert-bold"] = "alert-bold";
    BxfIconTypeEnum["alert-subtle-large"] = "alert-subtle-large";
    BxfIconTypeEnum["alert-subtle"] = "alert-subtle";
    BxfIconTypeEnum["alert"] = "alert";
    BxfIconTypeEnum["align-center"] = "align-center";
    BxfIconTypeEnum["align-left"] = "align-left";
    BxfIconTypeEnum["align-right"] = "align-right";
    BxfIconTypeEnum["analysis-result"] = "analysis-result";
    BxfIconTypeEnum["arrow-down"] = "arrow-down";
    BxfIconTypeEnum["arrow-dropdown-up"] = "arrow-dropdown-up";
    BxfIconTypeEnum["arrow-dropdown"] = "arrow-dropdown";
    BxfIconTypeEnum["arrow-left"] = "arrow-left";
    BxfIconTypeEnum["arrow-right"] = "arrow-right";
    BxfIconTypeEnum["arrow-up"] = "arrow-up";
    BxfIconTypeEnum["back-arrow"] = "back-arrow";
    BxfIconTypeEnum["bookmark-bold"] = "bookmark-bold";
    BxfIconTypeEnum["bookmark-subtle"] = "bookmark-subtle";
    BxfIconTypeEnum["briefcase"] = "briefcase";
    BxfIconTypeEnum["buy"] = "buy";
    BxfIconTypeEnum["bxf-arrow-right"] = "bxf-arrow-right";
    BxfIconTypeEnum["bxf-beta"] = "bxf-beta";
    BxfIconTypeEnum["bxf-calendar"] = "bxf-calendar";
    BxfIconTypeEnum["bxf-caution"] = "bxf-caution";
    BxfIconTypeEnum["bxf-caution48"] = "bxf-caution48";
    BxfIconTypeEnum["bxf-chat-blk-beta"] = "bxf-chat-blk-beta";
    BxfIconTypeEnum["bxf-chat"] = "bxf-chat";
    BxfIconTypeEnum["bxf-clear"] = "bxf-clear";
    BxfIconTypeEnum["bxf-close"] = "bxf-close";
    BxfIconTypeEnum["bxf-contact"] = "bxf-contact";
    BxfIconTypeEnum["bxf-copy"] = "bxf-copy";
    BxfIconTypeEnum["bxf-dismiss"] = "bxf-dismiss";
    BxfIconTypeEnum["bxf-double-down"] = "bxf-double-down";
    BxfIconTypeEnum["bxf-double-up"] = "bxf-double-up";
    BxfIconTypeEnum["bxf-email"] = "bxf-email";
    BxfIconTypeEnum["bxf-exit-full-screen"] = "bxf-exit-full-screen";
    BxfIconTypeEnum["bxf-full-screen"] = "bxf-full-screen";
    BxfIconTypeEnum["bxf-history"] = "bxf-history";
    BxfIconTypeEnum["bxf-kebab-menu"] = "bxf-kebab-menu";
    BxfIconTypeEnum["bxf-link-external"] = "bxf-link-external";
    BxfIconTypeEnum["bxf-loading"] = "bxf-loading";
    BxfIconTypeEnum["bxf-loading48"] = "bxf-loading48";
    BxfIconTypeEnum["bxf-logo-large"] = "bxf-logo-large";
    BxfIconTypeEnum["bxf-nav-active"] = "bxf-nav-active";
    BxfIconTypeEnum["bxf-nav-inactive"] = "bxf-nav-inactive";
    BxfIconTypeEnum["bxf-new-chat"] = "bxf-new-chat";
    BxfIconTypeEnum["bxf-panel-logo"] = "bxf-panel-logo";
    BxfIconTypeEnum["bxf-pdf"] = "bxf-pdf";
    BxfIconTypeEnum["bxf-phone"] = "bxf-phone";
    BxfIconTypeEnum["bxf-send"] = "bxf-send";
    BxfIconTypeEnum["bxf-sparkle-large"] = "bxf-sparkle-large";
    BxfIconTypeEnum["bxf-sparkle"] = "bxf-sparkle";
    BxfIconTypeEnum["bxf-stop"] = "bxf-stop";
    BxfIconTypeEnum["bxf-thumbs-down"] = "bxf-thumbs-down";
    BxfIconTypeEnum["bxf-thumbs-up"] = "bxf-thumbs-up";
    BxfIconTypeEnum["calendar"] = "calendar";
    BxfIconTypeEnum["cards"] = "cards";
    BxfIconTypeEnum["chat-attachment"] = "chat-attachment";
    BxfIconTypeEnum["chat-microphone"] = "chat-microphone";
    BxfIconTypeEnum["chat-new"] = "chat-new";
    BxfIconTypeEnum["chat-submit"] = "chat-submit";
    BxfIconTypeEnum["checkbox-mixed-state-2"] = "checkbox-mixed-state-2";
    BxfIconTypeEnum["checkmark"] = "checkmark";
    BxfIconTypeEnum["clear"] = "clear";
    BxfIconTypeEnum["clone"] = "clone";
    BxfIconTypeEnum["copilot-20"] = "copilot-20";
    BxfIconTypeEnum["copilot-32"] = "copilot-32";
    BxfIconTypeEnum["copilot-64"] = "copilot-64";
    BxfIconTypeEnum["copilot"] = "copilot";
    BxfIconTypeEnum["copy-to-clipboard"] = "copy-to-clipboard";
    BxfIconTypeEnum["data-custom-sort"] = "data-custom-sort";
    BxfIconTypeEnum["data-filter-a-z"] = "data-filter-a-z";
    BxfIconTypeEnum["data-filter-large-small"] = "data-filter-large-small";
    BxfIconTypeEnum["data-filter-small-large"] = "data-filter-small-large";
    BxfIconTypeEnum["data-filter-z-a"] = "data-filter-z-a";
    BxfIconTypeEnum["data-select-arrow-down"] = "data-select-arrow-down";
    BxfIconTypeEnum["data-select-arrow-up"] = "data-select-arrow-up";
    BxfIconTypeEnum["data-select-caret-down"] = "data-select-caret-down";
    BxfIconTypeEnum["data-select-caret-up"] = "data-select-caret-up";
    BxfIconTypeEnum["delete-small"] = "delete-small";
    BxfIconTypeEnum["delete-trash"] = "delete-trash";
    BxfIconTypeEnum["delete"] = "delete";
    BxfIconTypeEnum["detail"] = "detail";
    BxfIconTypeEnum["did-not-run"] = "did-not-run";
    BxfIconTypeEnum["download"] = "download";
    BxfIconTypeEnum["draw-arrow"] = "draw-arrow";
    BxfIconTypeEnum["draw-ellipse"] = "draw-ellipse";
    BxfIconTypeEnum["draw-freeform"] = "draw-freeform";
    BxfIconTypeEnum["draw-rectangle"] = "draw-rectangle";
    BxfIconTypeEnum["drawer-left"] = "drawer-left";
    BxfIconTypeEnum["drawer-right"] = "drawer-right";
    BxfIconTypeEnum["duplicate"] = "duplicate";
    BxfIconTypeEnum["edit"] = "edit";
    BxfIconTypeEnum["ellipsis"] = "ellipsis";
    BxfIconTypeEnum["error-bold"] = "error-bold";
    BxfIconTypeEnum["error-subtle-2"] = "error-subtle-2";
    BxfIconTypeEnum["error-subtle"] = "error-subtle";
    BxfIconTypeEnum["excel"] = "excel";
    BxfIconTypeEnum["export"] = "export";
    BxfIconTypeEnum["eye"] = "eye";
    BxfIconTypeEnum["favorite-bold-32"] = "favorite-bold-32";
    BxfIconTypeEnum["favorite-bold"] = "favorite-bold";
    BxfIconTypeEnum["favorite-subtle"] = "favorite-subtle";
    BxfIconTypeEnum["file"] = "file";
    BxfIconTypeEnum["filter-subtle"] = "filter-subtle";
    BxfIconTypeEnum["filter"] = "filter";
    BxfIconTypeEnum["folder-subtle"] = "folder-subtle";
    BxfIconTypeEnum["folder"] = "folder";
    BxfIconTypeEnum["globe"] = "globe";
    BxfIconTypeEnum["gripper"] = "gripper";
    BxfIconTypeEnum["help-bold"] = "help-bold";
    BxfIconTypeEnum["help-subtle"] = "help-subtle";
    BxfIconTypeEnum["help"] = "help";
    BxfIconTypeEnum["icon-detail"] = "icon-detail";
    BxfIconTypeEnum["icon-list"] = "icon-list";
    BxfIconTypeEnum["icon-widget-table"] = "icon-widget-table";
    BxfIconTypeEnum["icon-widget-visualization"] = "icon-widget-visualization";
    BxfIconTypeEnum["important-quotes"] = "important-quotes";
    BxfIconTypeEnum["info-2"] = "info-2";
    BxfIconTypeEnum["info-bold-large"] = "info-bold-large";
    BxfIconTypeEnum["info-bold"] = "info-bold";
    BxfIconTypeEnum["info-subtle-large"] = "info-subtle-large";
    BxfIconTypeEnum["info-subtle"] = "info-subtle";
    BxfIconTypeEnum["info"] = "info";
    BxfIconTypeEnum["inprogress-2"] = "inprogress-2";
    BxfIconTypeEnum["inprogress-bold-large"] = "inprogress-bold-large";
    BxfIconTypeEnum["inprogress-bold"] = "inprogress-bold";
    BxfIconTypeEnum["inprogress-subtle-large"] = "inprogress-subtle-large";
    BxfIconTypeEnum["inprogress-subtle"] = "inprogress-subtle";
    BxfIconTypeEnum["launch"] = "launch";
    BxfIconTypeEnum["layout"] = "layout";
    BxfIconTypeEnum["lightbulb"] = "lightbulb";
    BxfIconTypeEnum["like"] = "like";
    BxfIconTypeEnum["link"] = "link";
    BxfIconTypeEnum["list"] = "list";
    BxfIconTypeEnum["livechat"] = "livechat";
    BxfIconTypeEnum["loading"] = "loading";
    BxfIconTypeEnum["lock"] = "lock";
    BxfIconTypeEnum["log-in"] = "log-in";
    BxfIconTypeEnum["log-out"] = "log-out";
    BxfIconTypeEnum["mail"] = "mail";
    BxfIconTypeEnum["maximize"] = "maximize";
    BxfIconTypeEnum["menu"] = "menu";
    BxfIconTypeEnum["merge"] = "merge";
    BxfIconTypeEnum["mine"] = "mine";
    BxfIconTypeEnum["minimize"] = "minimize";
    BxfIconTypeEnum["monitor"] = "monitor";
    BxfIconTypeEnum["more-options"] = "more-options";
    BxfIconTypeEnum["move-all-down"] = "move-all-down";
    BxfIconTypeEnum["move-all-left"] = "move-all-left";
    BxfIconTypeEnum["move-all-right"] = "move-all-right";
    BxfIconTypeEnum["move-all-selected"] = "move-all-selected";
    BxfIconTypeEnum["move-all-unselected"] = "move-all-unselected";
    BxfIconTypeEnum["move-all-up"] = "move-all-up";
    BxfIconTypeEnum["move-folder"] = "move-folder";
    BxfIconTypeEnum["nested"] = "nested";
    BxfIconTypeEnum["new-2"] = "new-2";
    BxfIconTypeEnum["new-3"] = "new-3";
    BxfIconTypeEnum["new-bold-large"] = "new-bold-large";
    BxfIconTypeEnum["new-bold"] = "new-bold";
    BxfIconTypeEnum["new-subtle-large"] = "new-subtle-large";
    BxfIconTypeEnum["new-subtle"] = "new-subtle";
    BxfIconTypeEnum["open-order"] = "open-order";
    BxfIconTypeEnum["pause"] = "pause";
    BxfIconTypeEnum["phone"] = "phone";
    BxfIconTypeEnum["pin"] = "pin";
    BxfIconTypeEnum["play"] = "play";
    BxfIconTypeEnum["popin"] = "popin";
    BxfIconTypeEnum["popout"] = "popout";
    BxfIconTypeEnum["print"] = "print";
    BxfIconTypeEnum["progress-active-large"] = "progress-active-large";
    BxfIconTypeEnum["progress-active"] = "progress-active";
    BxfIconTypeEnum["progress-empty-large"] = "progress-empty-large";
    BxfIconTypeEnum["progress-empty"] = "progress-empty";
    BxfIconTypeEnum["redo"] = "redo";
    BxfIconTypeEnum["refresh"] = "refresh";
    BxfIconTypeEnum["reload"] = "reload";
    BxfIconTypeEnum["remove"] = "remove";
    BxfIconTypeEnum["routes"] = "routes";
    BxfIconTypeEnum["routing-controls"] = "routing-controls";
    BxfIconTypeEnum["running"] = "running";
    BxfIconTypeEnum["save"] = "save";
    BxfIconTypeEnum["search"] = "search";
    BxfIconTypeEnum["sell"] = "sell";
    BxfIconTypeEnum["settings-subtle"] = "settings-subtle";
    BxfIconTypeEnum["settings"] = "settings";
    BxfIconTypeEnum["share"] = "share";
    BxfIconTypeEnum["sigma"] = "sigma";
    BxfIconTypeEnum["split"] = "split";
    BxfIconTypeEnum["steering"] = "steering";
    BxfIconTypeEnum["stepper-down"] = "stepper-down";
    BxfIconTypeEnum["stepper-up"] = "stepper-up";
    BxfIconTypeEnum["success-bold-large"] = "success-bold-large";
    BxfIconTypeEnum["success-bold"] = "success-bold";
    BxfIconTypeEnum["success-subtle-large"] = "success-subtle-large";
    BxfIconTypeEnum["success-subtle"] = "success-subtle";
    BxfIconTypeEnum["table"] = "table";
    BxfIconTypeEnum["team"] = "team";
    BxfIconTypeEnum["template-loaded"] = "template-loaded";
    BxfIconTypeEnum["terminate"] = "terminate";
    BxfIconTypeEnum["text-bold"] = "text-bold";
    BxfIconTypeEnum["text-italic"] = "text-italic";
    BxfIconTypeEnum["text-underline"] = "text-underline";
    BxfIconTypeEnum["thumbs-down"] = "thumbs-down";
    BxfIconTypeEnum["ticker-negative"] = "ticker-negative";
    BxfIconTypeEnum["ticker-positive"] = "ticker-positive";
    BxfIconTypeEnum["undo"] = "undo";
    BxfIconTypeEnum["unlock"] = "unlock";
    BxfIconTypeEnum["up-down"] = "up-down";
    BxfIconTypeEnum["upload"] = "upload";
    BxfIconTypeEnum["uploader-32"] = "uploader-32";
    BxfIconTypeEnum["uploader-68"] = "uploader-68";
    BxfIconTypeEnum["use-workflow-colors"] = "use-workflow-colors";
    BxfIconTypeEnum["visualization"] = "visualization";
    BxfIconTypeEnum["waiting"] = "waiting";
    BxfIconTypeEnum["widget-delete"] = "widget-delete";
    BxfIconTypeEnum["widget-download"] = "widget-download";
    BxfIconTypeEnum["widget-duplicate"] = "widget-duplicate";
    BxfIconTypeEnum["widget-ellipsis"] = "widget-ellipsis";
    BxfIconTypeEnum["widget-export"] = "widget-export";
    BxfIconTypeEnum["widget-filter"] = "widget-filter";
    BxfIconTypeEnum["widget-footnote"] = "widget-footnote";
    BxfIconTypeEnum["widget-link"] = "widget-link";
    BxfIconTypeEnum["widget-maximize"] = "widget-maximize";
    BxfIconTypeEnum["widget-minimize"] = "widget-minimize";
    BxfIconTypeEnum["widget-pin"] = "widget-pin";
    BxfIconTypeEnum["widget-popout"] = "widget-popout";
    BxfIconTypeEnum["widget-refresh"] = "widget-refresh";
    BxfIconTypeEnum["widget-save"] = "widget-save";
    BxfIconTypeEnum["widget-settings"] = "widget-settings";
    BxfIconTypeEnum["widget-size-expand-grow"] = "widget-size-expand-grow";
    BxfIconTypeEnum["widget-size-expand-shrink"] = "widget-size-expand-shrink";
    BxfIconTypeEnum["widget-size-max"] = "widget-size-max";
    BxfIconTypeEnum["widget-size-smaller"] = "widget-size-smaller";
    BxfIconTypeEnum["widget-table"] = "widget-table";
    BxfIconTypeEnum["widget-upload"] = "widget-upload";
    BxfIconTypeEnum["widget-visualization"] = "widget-visualization";
    BxfIconTypeEnum["zoom-in"] = "zoom-in";
    BxfIconTypeEnum["zoom-out"] = "zoom-out";
})(BxfIconTypeEnum || (BxfIconTypeEnum = {}));

export { BxfIconTypeEnum as B };
